import { type FC } from "react";

import { Fonts, type ModalProps } from "@snapchat/snap-design-system";

import { modalStyle } from "../styles";

import { ActionModal } from "./ActionModal";

export type AddEmailToAccountModalProps = Omit<ModalProps, "children">;

export const AddEmailToAccountModal: FC<AddEmailToAccountModalProps> = (modalProps) => {
    return (
        <ActionModal {...modalProps} title="Email Address Required" footer={false} className={modalStyle}>
            <span style={Fonts.Paragraph.P200}>
                <p>
                    In order to use the Camera Kit portal, you need to have an email address associated with your
                    Snapchat account. Follow the steps below to add or verify your email address!
                </p>
                <p>
                    <a
                        href="https://support.snapchat.com/en-US/a/change-email"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Add or verify email address
                    </a>
                </p>
                <p>
                    <b>Refresh the page after verifying your email.</b>
                </p>
            </span>
        </ActionModal>
    );
};
